// extracted by mini-css-extract-plugin
export default {"content":"TxSendSuccessModal_content__SSsDj","container":"TxSendSuccessModal_container__oT4QN"};